import React from 'react'

export default function LoaderSkeleton({ className = '', style = {} }) {
  return (
    <div className={`loader-skeleton ${className}`} style={style} />
  )
}
